<template>
  <section class="content-intro section" :style="section.config.style">
    <div class="container">
      <div class="intro-grid" :class="[`layout-${section.config.layout}`]">
        <!-- 文本内容 -->
        <div class="intro-text">
          <h2 class="section-title">{{ section.config.title }}</h2>
          <div class="intro-content">
            <p 
              v-for="(paragraph, index) in section.config.content" 
              :key="index"
              class="intro-paragraph"
            >
              {{ paragraph }}
            </p>
          </div>
          
          <!-- 特性列表 -->
          <div class="features-grid" v-if="section.config.features">
            <div 
              v-for="feature in section.config.features" 
              :key="feature.id"
              class="feature-item"
            >
              <div class="feature-icon">{{ feature.icon }}</div>
              <div class="feature-content">
                <h3 class="feature-title">{{ feature.title }}</h3>
                <p class="feature-description">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 媒体内容 -->
        <div class="intro-media" v-if="section.config.mediaConfig">
          <div class="media-container" :class="[`media-${section.config.mediaConfig.type}`]">
            <!-- 图标类型 -->
            <div 
              v-if="section.config.mediaConfig.type === 'icon'"
              class="media-icon"
            >
              {{ section.config.mediaConfig.content }}
            </div>
            
            <!-- 图片类型 -->
            <img 
              v-else-if="section.config.mediaConfig.type === 'image'"
              :src="section.config.mediaConfig.content"
              :alt="section.config.title"
              class="media-image"
            />
            
            <!-- 视频类型 -->
            <video 
              v-else-if="section.config.mediaConfig.type === 'video'"
              :src="section.config.mediaConfig.content"
              class="media-video"
              controls
            ></video>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentIntro',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.content-intro {
  padding: 80px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.intro-grid {
  display: grid;
  gap: 4rem;
  align-items: center;
}

/* 布局类型 */
.layout-split {
  grid-template-columns: 2fr 1fr;
}

.layout-centered {
  grid-template-columns: 1fr;
  text-align: center;
}

.layout-full-width {
  grid-template-columns: 1fr;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--gray-900);
}

.intro-paragraph {
  font-size: 1.125rem;
  line-height: 1.8;
  color: var(--gray-600);
  margin-bottom: 1.5rem;
}

.intro-paragraph:last-child {
  margin-bottom: 0;
}

/* 特性网格 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.feature-item {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  padding: 1.5rem;
  background: var(--gray-50);
  border-radius: var(--radius-lg);
  border-left: 4px solid var(--primary-color);
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.feature-icon {
  font-size: 2rem;
  line-height: 1;
  flex-shrink: 0;
}

.feature-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.feature-description {
  font-size: 0.875rem;
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* 媒体容器 */
.intro-media {
  display: flex;
  justify-content: center;
  align-items: center;
}

.media-container {
  width: 100%;
  max-width: 400px;
}

.media-icon {
  font-size: 8rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 4px 8px rgba(30, 64, 175, 0.2));
  text-align: center;
}

.media-image {
  width: 100%;
  height: auto;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
}

.media-video {
  width: 100%;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .layout-split {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .features-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .content-intro {
    padding: 60px 0;
  }
  
  .intro-grid {
    gap: 3rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .intro-paragraph {
    font-size: 1rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .feature-item {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.75rem;
  }
  
  .media-icon {
    font-size: 6rem;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/ContentIntro.vue